// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input {
  border-radius: 1rem;
  background-color: white;
  position: relative;
  overflow: hidden;
  display: flex;
}
.text-input input {
  border: none;
  outline: none;
  background-color: white;
  height: 52px;
  padding: 0 32px 0 12px;
  width: 100%;
  font-size: 16px;
  font-family: "Inter", sans-serif;
}
.text-input input::placeholder {
  color: rgba(21, 21, 21, 0.5019607843);
}
.text-input__icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translate(0, -50%);
  cursor: pointer;
  height: 32px;
  width: 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/TextInput/TextInput.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADF;AAIE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AAFJ;AAII;EACE,qCCQK;ADVX;AAME;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EAEA,YAAA;EACA,WAAA;AALJ","sourcesContent":["@import \"src/styles/variables\";\n\n.text-input {\n  border-radius: 1rem;\n  background-color: white;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n\n\n  input {\n    border: none;\n    outline: none;\n    background-color: white;\n    height: 52px;\n    padding: 0 32px 0 12px;\n    width: 100%;\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n\n    &::placeholder {\n      color: $black-50;\n    }\n  }\n\n  &__icon {\n    position: absolute;\n    top: 50%;\n    right: 12px;\n    transform: translate(0, -50%);\n    cursor: pointer;\n\n    height: 32px;\n    width: 32px;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
